// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c6f2878","770":"5f0ded85"}[chunkId] + ".chunk.js";
};